import {jsonMember, jsonObject} from 'typedjson';
import {DataBase, TUPLA_TYPE} from './data-base';
import {DoraNumber} from '../Utility/dora-number';
import {formatDate} from '@angular/common';

declare function DoraGetLocale(): string;

// @ts-ignore
@jsonObject
export class DataTupla extends DataBase {
  @jsonMember
  private value: string;
  @jsonMember
  private type: string;
  @jsonMember
  private inputFormat: string;
  @jsonMember
  private outputFormat: string;
  @jsonMember
  private url: string;
  @jsonMember
  private rowspan: number;
  @jsonMember
  private customClass: string;

  get Rowspan(): number {
    if (this.rowspan === undefined) {
      return 0;
    }
    return this.rowspan;
  }

  public set Type(value: TUPLA_TYPE) {
    this.type = TUPLA_TYPE[value];
  }
  public get Type(): TUPLA_TYPE {
    return TUPLA_TYPE[this.type];
  }

  public get OutputFormat(): string {
    return this.outputFormat;
  }

  public set OutputFormat(value: string) {
    this.outputFormat = value;
  }

  public set Value(value: any) {
    this.value = value.toString();
  }
  public get Value(): any {
    switch (this.Type) {
      case TUPLA_TYPE.BOOLEAN:
        return Boolean(this.value);

      case TUPLA_TYPE.NUMBER:
        return Number(this.value);

      case TUPLA_TYPE.STRING:
        return this.value;

      case TUPLA_TYPE.DATETIME:
        return new Date(this.value);

      // todo mancano altri casi
      default:
        return this.value;
    }
  }
  public setValue(value: any, type: TUPLA_TYPE) {
    this.Value = value;
    this.Type = type;
  }
  public getFormattedValue(zeroValue: string, defaultFormat: string): string {
    switch (this.Type) {
      case TUPLA_TYPE.NUMBER:
        if (this.Value === 0) {
          return zeroValue;
        }
        return DoraNumber.formatNumber(this.Value,
            null,
            ((this.outputFormat === undefined || this.outputFormat === '') ? defaultFormat : this.outputFormat));
        // return formatNumber(this.Value, 'en', '1.1-3');

      case TUPLA_TYPE.PERCENTAGE:
        if (this.Value === 0) {
          return zeroValue;
        }
        return DoraNumber.formatNumber(this.Value * 100,
          null,
          ((this.outputFormat === undefined || this.outputFormat === '') ? defaultFormat : this.outputFormat));

      case TUPLA_TYPE.DATETIME:
        const localDate = formatDate(this.Value, 'shortDate', DoraGetLocale());
        return localDate;

      default:
        return this.Value;
    }
  }

  public clone(): DataTupla {
    const result: DataTupla = new DataTupla();

    result.setValue(this.Value, this.Type);

    // TODO: mancando altri attributi
    result.outputFormat = this.outputFormat;
    return result;
  }
}
